module.exports = __webpack_public_path__ + "img/Stage_6_Atmo.d64e83d9.jpg";